import { Injectable } from '@angular/core';
import { Issue, Customer, IssueType, Priority, IssueCategory, IssueState, ContactPersonal, User, UploadTask, AbstractChangeModel, ChangeModel, Product, IssueItem, GenericPostRequest, Offer, SearchObject, OfferItem, Address, ResponseWrapper, ShoppingCart, ProductPicture, Contract, ContactInformationType, ContractType, ContractState, ContractItem, Location, LocationClassification, AvailabilityComponent, AvailabilityState, Availability, Widget, WidgetType, Task, TaskType, ScheduleUserTask, Notification, NotificationTask, NotificationTaskType, CalendarEntry, CreateEventTask, LocalFile, MailUploadTask, CreateUserFilterTask, IssueMail, NextcloudFile, MailAttachement, UploadMailattachementModel, TransformIssueItemsTask } from '../classes';
import { BackEndService } from '../backend-service';
import { Observable, of, Subject } from 'rxjs';
import { WistaAMSTypes } from '../wista-ams-types';
import { FileService } from './file.service';
import * as moment from 'moment';
import { Guid, serverLocation } from '../globals';
import { shareReplay, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from '../lib/shared/services/token.service';

/**
 * @deprecated this service should not longer be used!
 */
@Injectable({
  providedIn: 'root'
})
export class DataService {

  public setBackgroundAnchor: Subject<boolean> = new Subject();
  public startPage: Widget[] = [];
  public startPageLoaded: boolean = false;
  public startPageLoading: boolean = false;
  public startPageLoadedAnchor: Subject<void> = new Subject();
  public startPageChanged: Subject<void> = new Subject();

  public widgetTypes: WidgetType[] = [];
  public widgetTypesLoaded: boolean = false;
  public widgetTypesLoading: boolean = false;
  public widgetTypesLoadedAnchor: Subject<void> = new Subject();

  public newsfeedObservables: { [key: string]: NewsfeedObservableEntry };
  public newsfeedObservablesLoaded: boolean = false;
  public newsfeedObservablesLoading: boolean = false;
  public newsfeedObservablesLoadedAnchor: Subject<void> = new Subject();

  public localChangesPullObservable: Subject<AbstractChangeModel[]> = new Subject();
  public localChanges: AbstractChangeModel[] = [];

  public issues: Issue[] = [];
  public issuesLoaded: number[] = [];
  public issuesLoading: number[] = [];
  public issuesSearched: string[] = [];
  public changesSearched: string[] = [];
  public incidentsSearched: string[] = [];
  public projectsSearched: string[] = [];
  public issuesSearchedAnchor: Subject<Issue[]> = new Subject();
  public issueOffersLoaded: number[] = [];
  public issueMails: IssueMail[] = [];
  public issueMailsLoaded: number[] = [];

  public locations: Location[] = [];
  public locationsLoaded: number[] = [];
  public locationsLoading: number[] = [];
  public locationsSearched: string[] = [];
  public locationsSearchedAnchor: Subject<Issue[]> = new Subject();

  public availabilities: Availability[] = [];
  public locationAvailabilitiesLoaded: number[] = [];

  public locationClassifications: LocationClassification[] = [];
  public allLocationClassificationsLoading: boolean = false;
  public locationClassificationsLoading: number[] = [];
  public allLocationClassificationsLoaded: boolean = false;
  public locationClassificationsLoaded: number[] = [];
  public locationClassificationsLoadedAnchor: Subject<LocationClassification[]> = new Subject();

  public availabilityComponents: AvailabilityComponent[] = [];
  public allAvailabilityComponentsLoading: boolean = false;
  public availabilityComponentsLoading: number[] = [];
  public allAvailabilityComponentsLoaded: boolean = false;
  public availabilityComponentsLoaded: number[] = [];
  public availabilityComponentsLoadedAnchor: Subject<AvailabilityComponent[]> = new Subject();

  public availabilityStates: AvailabilityState[] = [];
  public allAvailabilityStatesLoading: boolean = false;
  public availabilityStatesLoading: number[] = [];
  public allAvailabilityStatesLoaded: boolean = false;
  public availabilityStatesLoaded: number[] = [];
  public availabilityStatesLoadedAnchor: Subject<AvailabilityState[]> = new Subject();

  public allCustomersLoaded: boolean = false;
  public allCustomersLoading: boolean = false;
  public customers: Customer[] = [];
  public customersLoaded: number[] = [];
  public customersLoading: number[] = [];
  public customersLoadedAnchor: Subject<Customer[]> = new Subject();
  public customersSearched: string[] = [];
  public customersSearchedAnchor: Subject<void> = new Subject();
  public customerReplays: { [key: string]: Observable<Customer[]> } = {};

  public issueTypes: IssueType[] = [];
  public allIssueTypesLoading: boolean = false;
  public issueTypesLoading: number[] = [];
  public allIssueTypesLoaded: boolean = false;
  public issueTypesLoaded: number[] = [];
  public issueTypesLoadedAnchor: Subject<IssueType[]> = new Subject();

  public contractTypes: ContractType[] = [];
  public allContractTypesLoading: boolean = false;
  public contractTypesLoading: number[] = [];
  public allContractTypesLoaded: boolean = false;
  public contractTypesLoaded: number[] = [];
  public contractTypesLoadedAnchor: Subject<ContractType[]> = new Subject();

  public contractStates: ContractState[] = [];
  public allContractStatesLoading: boolean = false;
  public contractStatesLoading: number[] = [];
  public allContractStatesLoaded: boolean = false;
  public contractStatesLoaded: number[] = [];
  public contractStatesLoadedAnchor: Subject<ContractState[]> = new Subject();

  public contactInformationTypes: ContactInformationType[] = [];
  public allContactInformationTypesLoading: boolean = false;
  public allContactInformationTypesLoaded: boolean = false;
  public contactInformationTypesLoaded: number[] = [];
  public allContactInformationTypesLoadedAnchor: Subject<ContactInformationType[]> = new Subject();
  public contactInformationMailType: ContactInformationType;
  public contactInformationMobileType: ContactInformationType;
  public contactInformationPhoneType: ContactInformationType;
  public contactInformationFaxType: ContactInformationType;

  public issueTypeId: number = null;
  public changeTypeId: number = null;
  public incidentTypeId: number = null;
  public projectTypeId: number = null;

  public offers: Offer[] = [];
  public allOffersLoading: boolean = false;
  public offersLoading: number[] = [];
  public allOffersLoaded: boolean = false;
  public customerOffersMap = {};
  public offersLoaded: number[] = [];
  public offersLoadedAnchor: Subject<Offer[]> = new Subject();
  public offersSearched: string[] = [];
  public offersSearchedAnchor: Subject<Offer[]> = new Subject();

  public allIssueStatesLoaded: boolean = false;
  public allIssueStatesLoading: boolean = false;
  public issueStates: IssueState[] = [];
  public issueStatesLoading: number[] = [];
  public issueStatesLoaded: number[] = [];
  public issueStatesLoadedAnchor: Subject<IssueState[]> = new Subject();

  public allPrioritiesLoaded: boolean = false;
  public allPrioritiesLoading: boolean = false;
  public issuePriorities: Priority[] = [];
  public issuePrioritiesLoading: number[] = [];
  public issuePrioritiesLoaded: number[] = [];
  public issuePrioritiesLoadedAnchor: Subject<Priority[]> = new Subject();

  public allIssueCategoriesLoaded: boolean = false;
  public allIssueCategoriesLoading: boolean = false;
  public issueCategories: IssueCategory[] = [];
  public issueCategoriesLoading: number[] = [];
  public issueCategoriesLoaded: number[] = [];
  public issueCategoriesLoadedAnchor: Subject<IssueCategory[]> = new Subject();

  public allContactPersonsLoaded: boolean = false;
  public allContactPersonsLoading: boolean = false;
  public contactPersonal: ContactPersonal[] = [];
  public contactPersonalLoading: number[] = [];
  public contactPersonalLoaded: number[] = [];
  public contactPersonalLoadedAnchor: Subject<ContactPersonal[]> = new Subject();
  public contactpersonsSearched: string[] = [];
  public contactpersonsSearchedAnchor: Subject<ContactPersonal[]> = new Subject();

  public allProductsLoaded: boolean = false;
  public allProductsLoading: boolean = false;
  public products: Product[] = [];
  public productsLoading: number[] = [];
  public productsLoaded: number[] = [];
  public productsLoadedAnchor: Subject<Product[]> = new Subject();
  public productsSearched: string[] = [];
  public productsSearchedAnchor: Subject<Product[]> = new Subject();
  public productPictureMap = {};
  public productInGroupsLoaded = [];

  public allUsersLoaded: boolean = false;
  public allUsersLoading: boolean = false;
  public users: User[] = [];
  public usersLoadedAnchor: Subject<User[]> = new Subject();

  public addresses: Address[] = [];
  public addressesSearched: string[] = [];
  public addressesSearchedAnchor: Subject<Address[]> = new Subject();

  public shoppingCarts: ShoppingCart[] = [];
  public shoppingCartAddedAnchor: Subject<ShoppingCart> = new Subject();


  public contracts: Contract[] = [];
  public contractsSearched: string[] = [];
  public contractsLoading: number[] = [];
  public contractsLoaded: number[] = [];
  public customerContractsLoaded: number[] = [];
  public contractsSearchedAnchor: Subject<Contract[]> = new Subject<Contract[]>();

  public uploadTasks: UploadTask[] = [];

  //public mails: Mail[] = [];

  public currentObservables: ObservableResolver[] = [];

  constructor(
    private _backEndService: BackEndService,
    private _httpClient: HttpClient,
    private _tokenService: TokenService,
    private _fileService: FileService
  ) { }

  addCustomer(customer: Customer) {
    if (!this.customers.find(x => x.customerid == customer.customerid)) this.customers.push(customer);
  }
  addIssue(issue: Issue) {
    if (!this.issues.find(x => x.issueid == issue.issueid)) this.issues.push(issue);
  }

  addCustomers(customers: Customer[]) {
    for (let customer of customers) this.addCustomer(customer);
  }
  addIssues(issues: Issue[]) {
    for (let issue of issues) this.addIssue(issue);
  }
  addShoppingCart(cart: ShoppingCart) {
    this.shoppingCarts.push(cart);
    this.shoppingCartAddedAnchor.next(cart);
  }
  addProducts(products: Product[]) {
    for (let product of products) this.addProduct(product);
  }
  addProduct(product: Product) {
    if (!this.products.find(x => x.productid == product.productid)) this.products.push(product);
  }

  getCustomerContacts(customerId: number): Observable<ContactPersonal[]> {
    return (this._backEndService.get(`api/customer/${customerId}/contacts`) as Observable<ContactPersonal[]>).pipe(tap((contacts) => {
      contacts.forEach(x => {
        x.isValidated = false;
        let index = this.contactPersonal.findIndex(x => x.contactpersid === x.contactpersid);
        if(index === -1) this.contactPersonal.push(x);
      });
    }));  
  }

  loadAvailabilityComponents() {
    this.allAvailabilityComponentsLoading = true;
    this._backEndService.get("api/availabilitycomponent").subscribe((components: AvailabilityComponent[]) => {
      this.availabilityComponents = components;
      this.availabilityComponentsLoaded = components.map(x => x.availabilitycomponentid);
      this.availabilityComponentsLoading = [];
      this.allAvailabilityComponentsLoading = false;
      this.allAvailabilityComponentsLoaded = true;
      this.availabilityComponentsLoadedAnchor.next();
    });
  }

  loadAvailabilityStates() {
    this.allAvailabilityStatesLoading = true;
    this._backEndService.get("api/availabilitystate").subscribe((components: AvailabilityState[]) => {
      this.availabilityStates = components;
      this.availabilityStatesLoaded = components.map(x => x.availabilitystateid);
      this.availabilityStatesLoading = [];
      this.allAvailabilityStatesLoading = false;
      this.allAvailabilityStatesLoaded = true;
      this.availabilityStatesLoadedAnchor.next();
    });
  }

  loadContactPersons() {
    this.allContactPersonsLoading = true;
    this._backEndService.get("api/contactpersonal").subscribe((contactPersonal: ContactPersonal[]) => {
      for (let c of contactPersonal) {
        c.isValidated = false;
        c.isNew = false;
        let i = this.contactPersonalLoaded.indexOf(c.contactpersid);
        if (i == -1) this.customersLoaded.push(c.contactpersid);
      }
      this.contactPersonal = contactPersonal;
      this.contactPersonalLoading = [];
      this.allContactPersonsLoading = false;
      this.allContactPersonsLoaded = true;
      this.contactPersonalLoadedAnchor.next(this.contactPersonal);
    });
  }

  loadCustomers() {
    this.allCustomersLoading = true;
    this._backEndService.get("api/customer").subscribe((customers: Customer[]) => {
      for (let c of customers) {
        c.isValidated = false;
        c.isNew = false;
        let i = this.customersLoaded.indexOf(c.customerid);
        if (i == -1) this.customersLoaded.push(c.customerid);
      }
      this.customers = customers;
      this.customersLoading = [];
      this.allCustomersLoading = false;
      this.allCustomersLoaded = true;
      this.customersLoadedAnchor.next(this.customers);
    });
  }

  loadLocationClassifications() {
    this.allLocationClassificationsLoading = true;
    this._backEndService.get("api/locationclassification").subscribe((classifications: LocationClassification[]) => {
      this.locationClassifications = classifications;
      this.locationClassificationsLoaded = classifications.map(x => x.classificationid);
      this.locationClassificationsLoading = [];
      this.allLocationClassificationsLoading = false;
      this.allLocationClassificationsLoaded = true;
      this.locationClassificationsLoadedAnchor.next();
    });
  }

  loadIssueCategories() {
    this.allIssueCategoriesLoading = true;
    this._backEndService.get("api/issuecategory").subscribe((categories: IssueCategory[]) => {
      this.issueCategories = categories;
      for (let c of categories) {
        let i = this.issueCategoriesLoaded.indexOf(c.categoryid);
        if (i == -1) this.issueCategoriesLoaded.push(c.categoryid);
      }
      this.allIssueCategoriesLoading = false;
      this.allIssueCategoriesLoaded = true;
      this.issueCategoriesLoadedAnchor.next();
    });
  }

  loadIssuePriorities() {
    this.allPrioritiesLoading = true;
    this._backEndService.get("api/priority").subscribe((priorities: Priority[]) => {
      this.issuePriorities = priorities;
      for (let p of priorities) {
        let i = this.issuePrioritiesLoading.indexOf(p.priorityid);
        if (i == -1) this.issuePrioritiesLoaded.push(p.priorityid);
      }
      this.issuePrioritiesLoading = [];
      this.allPrioritiesLoading = false;
      this.allPrioritiesLoaded = true;
      this.issuePrioritiesLoadedAnchor.next();
    });
  }

  loadIssueStates() {
    this.allIssueStatesLoading = true;
    this._backEndService.get("api/issue-status").subscribe((states: IssueState[]) => {
      this.issueStates = states;
      for (let s of states) {
        let i = this.issueStatesLoaded.indexOf(s.stateid);
        if (i == -1) this.issueTypesLoaded.push(s.stateid);
      }
      this.issueStatesLoading = [];
      this.allIssueStatesLoading = false;
      this.allIssueStatesLoaded = true;
      this.issueStatesLoadedAnchor.next();
    });
  }

  loadContactInformationTypes() {
    this.allContactInformationTypesLoading = true;
    this._backEndService.get("api/contactinformationtype").subscribe((types: ContactInformationType[]) => {
      this.contactInformationTypes = types;
      for (let type of types) {
        switch (type.typename) {
          case "E-Mail":
            type.icon = "alternate_email";
            this.contactInformationMailType = type;
            break;
          case "Telefon geschäftlich":
            type.icon = "call";
            this.contactInformationPhoneType = type;
            break;
          case "Mobil":
            type.icon = "smartphone";
            this.contactInformationMobileType = type;
            break;
          case "Fax":
            type.icon = "scanner";
            this.contactInformationFaxType = type;
            break;
        }
      }
      this.allContactInformationTypesLoading = false;
      this.allContactInformationTypesLoaded = true;
      this.contactInformationTypesLoaded = types.map(x => x.typeid);
      this.allContactInformationTypesLoadedAnchor.next(types);
    });
  }

  loadIssueTypes() {
    this.allIssueTypesLoading = true;
    this._backEndService.get("api/issuetype").subscribe((types: IssueType[]) => {
      this.issueTypes = types;
      for (let t of types) {
        let i = this.issueTypesLoaded.indexOf(t.typeid);
        if (i == -1) this.issueTypesLoaded.push(t.typeid);
        if (t.typename) {
          switch (t.typename) {
            case "Change":
              this.changeTypeId = t.typeid;
              break;
            case "Incident":
              this.incidentTypeId = t.typeid;
              break;
            case "Projekt":
              this.projectTypeId = t.typeid;
              break;
            case "Vorgang":
              this.issueTypeId = t.typeid;
              break;
            default:
              console.warn("unknwon issue type detected: " + t.typename);
              break;
          }
        }
      }
      this.allIssueTypesLoading = false;
      this.allIssueTypesLoaded = true;
      this.issueTypesLoadedAnchor.next();
    });
  }
  /**
   * @deprecated
   */
  loadContractStates() {
    this.allContractStatesLoading = true;
    this._backEndService.get("api/contract-status").subscribe((states: ContractState[]) => {
      this.contractStates = states;
      this.contractStatesLoaded = states.map(x => x.contractstateid);
      this.allContractStatesLoading = false;
      this.allContractStatesLoaded = true;
      this.contractStatesLoadedAnchor.next();
    });
  }

  loadContractTypes() {
    this.allContractTypesLoading = true;
    this._backEndService.get("api/contracttype").subscribe((types: ContractType[]) => {
      this.contractTypes = types;
      this.contractTypesLoaded = types.map(x => x.contracttypeid);
      this.allContractTypesLoading = false;
      this.allContractTypesLoaded = true;
      this.contractTypesLoadedAnchor.next();
    });
  }

  loadNextIssueId() {
    return this._backEndService.get("api/issue/generateId");
  }

  loadProducts() {
    this.allProductsLoading = true;
    this._backEndService.get("api/product").subscribe((products: Product[]) => {
      this.products = products;
      for (let p of products) {
        let i = this.productsLoaded.indexOf(p.productid);
        if (i == -1) this.productsLoaded.push(p.productid);
      }
      this.allProductsLoading = false;
      this.allProductsLoaded = true;
      this.productsLoadedAnchor.next(products);
      this.productsLoadedAnchor.complete();
    });
  }

  loadUsers() {
    this.allUsersLoading = true;
    this._backEndService.get("api/account").subscribe((users: User[]) => {
      this.users = users;
      this.allUsersLoading = false;
      this.allUsersLoaded = true;
      this.usersLoadedAnchor.next();
    });
  }

  overwriteIssue(issue: Issue) {
    let oldIssue = this.issues.find(x => x.issueid == issue.issueid);
    let index = this.issues.indexOf(oldIssue);
    if (index > -1) this.issues[index] = issue;
  }

  changeObservable: Subject<AbstractChangeModel[]> = new Subject();
  /**
   * discards a change and triggers the change and the rejected observable
   * @param change
   */
  discardChange(change: AbstractChangeModel) {
    this.removeChange(change);
    (change as ChangeModel<any>).changeRejectedObservable.next();
  }
  /**
   * removes a local change and triggers the change observable exclusively
   * @param change 
   */
  removeChange(change: AbstractChangeModel) {
    let i = this.localChanges.indexOf(change);
    if (i > -1) this.localChanges.splice(i, 1);
    this.changeObservable.next(this.localChanges);
  }

  removeContactperson(contactperson: ContactPersonal) {
    let i = this.contactPersonal.indexOf(contactperson);
    if (i > -1) this.contactPersonal.splice(i, 1);
  }
  /**
   * the method deletes a contract from the current local session
   * @param contract 
   */
  removeContract(contract: Contract) {
    var i = this.contracts.findIndex(x => x.contractid == contract.contractid);
    if (i > -1) this.contracts.splice(i, 1);
    i = this.contractsLoaded.findIndex(x => x == contract.contractid);
    if (i > -1) this.contractsLoaded.splice(i, 1);
  }
  /**
   * the method saves a change
   */
  saveChange(change: ChangeModel<any>): Subject<Object> {
    var url: string, object: any, ref: any[], id: string;
    let anchor: Subject<Object> = new Subject();
    let callback = (result: ResponseWrapper<any>) => {
      change.newModel.isNew = false;
      change.newModel.isChanged = false;
      if (ref && id) {
        let i = ref.findIndex(x => x[id] == result.content[id]);
        if (i > -1) ref[i] = result.content;
        else ref.push(result.content);
      }
      change.newModelIsPersisted = true;
      anchor.next(result);
      if (Array.isArray(change.scheduleTasks)) {
        for (let task of change.scheduleTasks) {
          let callback = () => {
            let i = change.scheduleTasks.indexOf(task);
            if (i > -1) change.scheduleTasks.splice(i, 1);
            DataService.checkChange(change, result);
          }
          if (task.schedule) this._backEndService.get("api/issue/" + (result as ResponseWrapper<Issue>).content.issueid + "/assign/" + task.user.id).subscribe(() => callback());
          else this._backEndService.get("api/issue/" + (result as ResponseWrapper<Issue>).content.issueid + "/unassign/" + task.user.id).subscribe(() => callback());
        }
      }
      if (Array.isArray(change.availabilityTasks)) {
        for (let task of change.availabilityTasks) {
          if ((result.content as Location).locationid) task.location = (result.content as Location).locationid;
          let callback = () => {
            let i = change.availabilityTasks.indexOf(task);
            if (i > -1) change.availabilityTasks.splice(i, 1);
            DataService.checkChange(change, result);
          }
          if (!task.availability && !task.state) {
            console.warn("invalid availability: no availability id and no state!", task);
            callback();
          } else {
            if (task.availability) {
              if (task.state) this._backEndService.put("api/availability", {
                availabilityid: task.availability,
                availabilitycomponent: task.component,
                availabilitylocation: task.location,
                availabilitystate: task.state
              } as Availability).subscribe((result: Availability) => {
                let i = this.availabilities.findIndex(x => x.availabilityid === result.availabilityid);
                if (i > -1) this.availabilities[i] = result;
                callback();
              });
              else this._backEndService.delete("api/availability/" + task.availability).subscribe((result: Availability) => {
                let i = this.availabilities.findIndex(x => x.availabilityid === result.availabilityid);
                if (i > -1) this.availabilities.splice(i, 1);
                callback();
              });
            } else {
              this._backEndService.post("api/availability", {
                availabilitycomponent: task.component,
                availabilitylocation: task.location,
                availabilitystate: task.state
              } as Availability).subscribe((result: Availability) => {
                this.availabilities.push(result);
                callback();
              });
            }
          }
        }
      }
      DataService.checkChange(change, result);
    };
    if (!change) {
      console.warn("cannot save change: no change passed!");
      return;
    }
    switch (change.type) {
      case WistaAMSTypes.Customer:
        url = "api/customer";
        object = {
          "customerid": (change.newModel as Customer).customerid,
          "customeraddress": (change.newModel as Customer).customeraddress,
          "customerfax": (change.newModel as Customer).customerfax,
          "customermail": (change.newModel as Customer).customermail,
          "customername": (change.newModel as Customer).customername,
          "customernote": (change.newModel as Customer).customernote,
          "customernumber": (change.newModel as Customer).customernumber,
          "customerphone": (change.newModel as Customer).customerphone,
          "customeractive": (change.newModel as Customer).customeractive
        } as Customer;
        ref = this.customers, id = "customerid";
        break;
      case WistaAMSTypes.Contract:
        url = "api/contract";
        object = {
          "contractcustomer": (change.newModel as Contract).contractcustomer,
          "contractdesc": (change.newModel as Contract).contractdesc,
          "contractid": (change.newModel as Contract).contractid,
          "contractnote": (change.newModel as Contract).contractnote,
          "contractnumber": (change.newModel as Contract).contractnumber,
          "contractstate": (change.newModel as Contract).contractstate,
          "contracttype": (change.newModel as Contract).contracttype,
          "contractlocation": (change.newModel as Contract).contractlocation
        } as Contract;
        ref = this.contracts, id = "contractid";
        break;
      case WistaAMSTypes.Issue:
      case WistaAMSTypes.Incident:
      case WistaAMSTypes.Change:
      case WistaAMSTypes.Project:
        url = "api/issue";
        object = {
          "issueid": (change.newModel as Issue).issueid,
          "changetype": (change.newModel as Issue).changetype,
          "commercialcontactpersonalid": (change.newModel as Issue).commercialcontactpersonalid,
          "localcontactpersonalid": (change.newModel as Issue).localcontactpersonalid,
          "folderlocation": (change.newModel as Issue).folderlocation,
          "issuecategory": (change.newModel as Issue).issuecategory,
          "issuecustomer": (change.newModel as Issue).issuecustomer,
          "issuedesc": (change.newModel as Issue).issuedesc,
          "issueescalation": (change.newModel as Issue).issueescalation,
          "issuenote": (change.newModel as Issue).issuenote,
          "issuenumber": (change.newModel as Issue).issuenumber,
          "issuepriority": (change.newModel as Issue).issuepriority,
          "issuestate": (change.newModel as Issue).issuestate,
          "issuetitle": (change.newModel as Issue).issuetitle,
          "issuetype": (change.newModel as Issue).issuetype
        } as Issue;
        ref = this.issues, id = "issueid";
        break;
      case WistaAMSTypes.IssueItem:
        url = "api/issueitem";
        object = {
          "itemid": (change.newModel as IssueItem).itemid,
          "itemcanceldate": (change.newModel as IssueItem).itemcanceldate,
          "itemcontract": (change.newModel as IssueItem).itemcontract,
          "itemcount": (change.newModel as IssueItem).itemcount,
          "itemdesc": (change.newModel as IssueItem).itemdesc,
          "iteminfo": (change.newModel as IssueItem).iteminfo,
          "itembuildindate": (change.newModel as IssueItem).itembuildindate,
          "itemfaktdate": (change.newModel as IssueItem).itemfaktdate,
          "itemissue": (change.newModel as IssueItem).itemissue,
          "itemlocation": (change.newModel as IssueItem).itemlocation,
          "itemname": (change.newModel as IssueItem).itemname,
          "itemposition": (change.newModel as IssueItem).itemposition,
          "itemproduct": (change.newModel as IssueItem).itemproduct,
          "itempurchasecost": (change.newModel as IssueItem).itempurchasecost,
          "itemrentalcost": (change.newModel as IssueItem).itemrentalcost,
          "itemsetupcost": (change.newModel as IssueItem).itemsetupcost
        } as IssueItem;
        break;
      case WistaAMSTypes.Offer:
        url = "api/offer";
        object = {
          "offerid": (change.newModel as Offer).offerid,
          "offerbillingaddress": (change.newModel as Offer).offerbillingaddress,
          "offerdesc": (change.newModel as Offer).offerdesc,
          "offerissue": (change.newModel as Offer).offerissue,
          "offerserviceaddress": (change.newModel as Offer).offerserviceaddress,
          "offertitle": (change.newModel as Offer).offertitle,
          "commercialcontact": (change.newModel as Offer).commercialcontact,
          "localcontact": (change.newModel as Offer).localcontact,
          "customoffernote": (change.newModel as Offer).customoffernote,
          "offercustomer": (change.newModel as Offer).offercustomer
        } as Offer;
        ref = this.offers, id = "offerid";
        break;
      case WistaAMSTypes.OfferItem:
        url = "api/offer-item";
        object = {
          "itemid": (change.newModel as OfferItem).itemid,
          "itemcanceldate": (change.newModel as OfferItem).itemcanceldate,
          "itemcontract": (change.newModel as OfferItem).itemcontract,
          "itemcount": (change.newModel as OfferItem).itemcount,
          "itemdesc": (change.newModel as OfferItem).itemdesc,
          "iteminfo": (change.newModel as OfferItem).iteminfo,
          "itembuildindate": (change.newModel as OfferItem).itembuildindate,
          "itemfaktdate": (change.newModel as OfferItem).itemfaktdate,
          "itemlocation": (change.newModel as OfferItem).itemlocation,
          "itemoffer": (change.newModel as OfferItem).itemoffer,
          "itemposition": (change.newModel as OfferItem).itemposition,
          "itemproduct": (change.newModel as OfferItem).itemproduct,
          "itempurchasecost": (change.newModel as OfferItem).itempurchasecost,
          "itemrentalcost": (change.newModel as OfferItem).itemrentalcost,
          "itemsetupcost": (change.newModel as OfferItem).itemsetupcost,
          "itemterm": (change.newModel as OfferItem).itemterm,
          "itemselected": (change.newModel as OfferItem).itemselected,
          "itemissue": (change.newModel as OfferItem).itemissue
        } as OfferItem;
        break;
      case WistaAMSTypes.Address:
        url = "api/address";
        object = {
          "addresscity": (change.newModel as Address).addresscity,
          "addresshousenumber": (change.newModel as Address).addresshousenumber,
          "addressid": (change.newModel as Address).addressid,
          "addressnote": (change.newModel as Address).addressnote,
          "addressstreet": (change.newModel as Address).addressstreet,
          "addressaddition": (change.newModel as Address).addressaddition,
          "addresscountry": (change.newModel as Address).addresscountry,
          "addresszipcode": (change.newModel as Address).addresszipcode
        } as Address;
        break;
      case WistaAMSTypes.ContactPersonal:
        url = "api/contactpersonal";
        object = {
          "contactpersaddress": (change.newModel as ContactPersonal).contactpersaddress,
          "contactpersfname": (change.newModel as ContactPersonal).contactpersfname,
          "contactpersid": (change.newModel as ContactPersonal).contactpersid,
          "contactpersinfo": (change.newModel as ContactPersonal).contactpersinfo,
          "contactperslname": (change.newModel as ContactPersonal).contactperslname,
          "contactpersmail": (change.newModel as ContactPersonal).contactpersmail,
          "contactpersondepartment": (change.newModel as ContactPersonal).contactpersondepartment,
          "contactpersphone": (change.newModel as ContactPersonal).contactpersphone,
          "contactperspublicid": (change.newModel as ContactPersonal).contactperspublicid,
          "contactperssalutation": (change.newModel as ContactPersonal).contactperssalutation
        } as ContactPersonal;
        break;
      case WistaAMSTypes.ContractItem:
        url = "api/contractitem";
        object = {
          "itembuildindate": (change.newModel as ContractItem).itembuildindate,
          "itemcanceldate": (change.newModel as ContractItem).itemcanceldate,
          "itemcontractid": (change.newModel as ContractItem).itemcontractid,
          "itemcount": (change.newModel as ContractItem).itemcount,
          "itemdesc": (change.newModel as ContractItem).itemdesc,
          "itemfaktdate": (change.newModel as ContractItem).itemfaktdate,
          "itemid": (change.newModel as ContractItem).itemid,
          "iteminfo": (change.newModel as ContractItem).iteminfo,
          "itemlocation": (change.newModel as ContractItem).itemlocation,
          "itemname": (change.newModel as ContractItem).itemname,
          "itemposition": (change.newModel as ContractItem).itemposition,
          "itemproduct": (change.newModel as ContractItem).itemproduct,
          "itempurchasecost": (change.newModel as ContractItem).itempurchasecost,
          "itemrentalcost": (change.newModel as ContractItem).itemrentalcost,
          "itemsetupcost": (change.newModel as ContractItem).itemsetupcost
        } as ContractItem;
        break;
      case WistaAMSTypes.Location:
        url = "api/location";
        object = {
          "locationaddress": (change.newModel as Location).locationaddress,
          "locationclassification": (change.newModel as Location).locationclassification,
          "locationfloor": (change.newModel as Location).locationfloor,
          "locationid": (change.newModel as Location).locationid,
          "locationinfo": (change.newModel as Location).locationinfo,
          "locationparent": (change.newModel as Location).locationparent,
          "locationpart": (change.newModel as Location).locationpart
        } as Location;
        break;
    }
    if (!url) {
      console.warn("cannot save change!", change, url);
      return;
    }
    if ((change.newModel as any).isNew) {
      this._backEndService.post(url, {
        content: object,
        note: change.auditNote
      } as GenericPostRequest<any>).subscribe((result: any) => callback(result));
    } else {
      this._backEndService.put(url, {
        content: object,
        note: change.auditNote
      } as GenericPostRequest<any>).subscribe((result: any) => callback(result));
    }
    return anchor;
  }

  unseenNotificationsLoaded: boolean = false;
  notifications: Notification[] = [];
  notificationsChangedAnchor: Subject<void> = new Subject();

  loadUnseenNotifications() {
    this._httpClient.get(`${serverLocation}/api/notification/unseen`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }).subscribe((notifications: Notification[]) => {
      for (let notification of notifications) {
        if (!this.notifications.find(x => x.notificationid == notification.notificationid)) this.notifications.push(notification);
      }
      this.notificationsChangedAnchor.next();
    });
  }

  getLocalChangeByOldObject(object: any): AbstractChangeModel {
    return this.localChanges.find(x => (x as any).serverModel === object);
  }

  getLocalChangeByNewObject(object: any): AbstractChangeModel {
    return this.localChanges.find(x => (x as any).newModel === object);
  }

  registerChange(change: AbstractChangeModel) {
    this.localChanges.push(change);
    this.changeObservable.next(this.localChanges);
  }

  removeCustomer(customer: Customer) {
    var index = this.customers.indexOf(customer);
    if (index > -1) this.customers.splice(index, 1);
    index = this.customersLoaded.indexOf(customer.customerid);
    if (index > -1) this.customersLoaded.splice(index, 1);
    index = this.customersLoading.indexOf(customer.customerid);
    if (index > -1) this.customersLoading.splice(index, 1);
  }

  removeIssue(issue: Issue) {
    let index = this.issues.indexOf(issue);
    if (index > -1) this.issues.splice(index, 1);
  }

  resolve(type: number, identifier: number, pipe: any, overwrite: boolean = false) {
    let cb = (object: any) => {
      pipe(object);
    };
    var res = this.currentObservables.find(x => x.identfier === identifier && x.type === type);
    if (!overwrite) {
      switch (type) {
        case WistaAMSTypes.Issue:
          if (this.issuesLoaded.includes(identifier)) {
            cb(this.issues.find(x => x.issueid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.IssuePriority:
          if (this.issuePrioritiesLoaded.includes(identifier)) {
            cb(this.issuePriorities.find(x => x.priorityid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.IssueCategory:
          if (this.issueCategoriesLoaded.includes(identifier)) {
            cb(this.issueCategories.find(x => x.categoryid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.Customer:
          let customer = this.customers.find(x => x.customerid == identifier);
          if (customer && customer.isValidated) {
            cb(customer);
            return;
          }
          break;
        case WistaAMSTypes.IssueState:
          if (this.issueStatesLoaded.includes(identifier)) {
            cb(this.issueStates.find(x => x.stateid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.ContactPersonal:
          if (this.contactPersonalLoaded.includes(identifier)) {
            cb(this.contactPersonal.find(x => x.contactpersid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.IssueType:
          if (this.issueTypesLoaded.includes(identifier)) {
            cb(this.issueTypes.find(x => x.typeid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.Offer:
          if (this.offersLoaded.includes(identifier)) {
            cb(this.offers.find(x => x.offerid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.ProductPicture:
          if (this.productPictureMap[identifier]) {
            cb(this.productPictureMap[identifier]);
            return;
          }
          break;
        case WistaAMSTypes.ProductInGroup:
          if (this.productInGroupsLoaded.includes(identifier)) {
            cb(this.products.filter(x => x.productgroup == identifier));
            return;
          }
          break;
        case WistaAMSTypes.CustomerContracts:
          if (this.customerContractsLoaded.includes(identifier)) {
            cb(this.contracts.filter(x => x.contractcustomer == identifier));
            return;
          }
          break;
        case WistaAMSTypes.CustomerOffers:
          if (this.customerOffersMap[identifier.toString()]) {
            cb(this.customerOffersMap[identifier.toString()]);
            return;
          }
          break;
        case WistaAMSTypes.IssueOffers:
          if (this.issueOffersLoaded.includes(identifier)) {
            cb(this.offers.filter(x => x.offerissue == identifier));
            return;
          }
          break;
        case WistaAMSTypes.IssueMails:
          if (this.issueMailsLoaded.includes(identifier)) {
            cb(this.issueMails.filter(x => x.issueid === identifier));
            return;
          }
          break;
        case WistaAMSTypes.Contract:
          if (this.contractsLoaded.includes(identifier)) {
            cb(this.contracts.find(x => x.contractid == identifier));
            return;
          }
          break;
        case WistaAMSTypes.ContractState:
          if (this.contractStatesLoaded.includes(identifier)) {
            cb(this.contractStates.find(x => x.contractstateid == identifier));
            return;
          }
          break;
        case WistaAMSTypes.ContractType:
          if (this.contractsLoaded.includes(identifier)) {
            cb(this.contractTypes.find(x => x.contracttypeid == identifier));
            return;
          }
          break;
        case WistaAMSTypes.Location:
          if (this.locationsLoaded.includes(identifier)) {
            cb(this.locations.find(x => x.locationid == identifier));
            return;
          }
          break;
        case WistaAMSTypes.LocationAvailabilities:
          if (this.locationAvailabilitiesLoaded.includes(identifier)) {
            cb(this.availabilities.filter(x => x.availabilitylocation == identifier));
            return;
          }
          break;
        case WistaAMSTypes.Product:
          let product = this.products.find(x => x.productid == identifier);
          if (product) {
            cb(product);
            return;
          }
          break;
        case WistaAMSTypes.Address:
          break;
        default:
          throw ("cannot resolve observable, identifier: " + identifier + ", type: " + type);
      }
    }
    if (!res) {
      res = new ObservableResolver();
      res.identfier = identifier;
      res.type = type;
      this.resolveObservable(res, overwrite);
    }
    res.handle.subscribe((object: any) => {
      cb(object);
    });
  }

  resolveMultiple(args: ResolveObject[], response: ResolveResponseWrapper) {
    if (args.length === 0) {
      response.onAllResolved.next([]);
      response.dispose();
      return;
    }
    let output = [];
    for (let arg of args) {
      this.resolve(arg.type, arg.identifier, (result) => {
        let resultWrapper = { "arg": arg, result: result } as ResolveResponse;
        output.push(resultWrapper);
        response.onResolved.next(resultWrapper);
        if (typeof arg.callback === 'function') arg.callback(result);
        if (args.length === output.length) response.onAllResolved.next(output);
      });
    }
  }

  private resolveObservable(res: ObservableResolver, overwrite: boolean) {
    var url = null;
    var onLoaded = (object: any) => {
      // console.warn("missing handler for " + res.type, res);
    };
    switch (res.type) {
      case WistaAMSTypes.ChangeType:
        url = "api/changetype/" + res.identfier;
        break;
      case WistaAMSTypes.Issue:
        url = "api/issue/" + res.identfier;
        onLoaded = (result: Issue) => {
          var i = this.issuesLoading.indexOf(res.identfier);
          if (i > -1) this.issuesLoading.splice(i, 1);
          if (overwrite) {
            i = this.issues.findIndex(x => x.issueid == result.issueid);
            if (i > -1) this.issues.splice(i, 1);
            i = this.issuesLoaded.findIndex(x => x == result.issueid);
            if (i > -1) this.issuesLoaded.splice(i, 1);
          }
          if (!this.issues.find(x => x.issueid == result.issueid)) this.issues.push(result);
          if (!this.issuesLoaded.find(x => x == result.issueid)) this.issuesLoaded.push(result.issueid);
        };
        break;
      case WistaAMSTypes.IssuePriority:
        url = "api/priority/" + res.identfier;
        break;
      case WistaAMSTypes.IssueCategory:
        url = "api/issuecategory/" + res.identfier;
        break;
      case WistaAMSTypes.Customer:
        url = "api/customer/" + res.identfier;
        onLoaded = (result: Customer) => {
          result.isValidated = true;
          let i = this.customersLoading.indexOf(res.identfier);
          if (i > -1) this.customersLoading.splice(i, 1);
          if (overwrite) {
            i = this.customers.findIndex(x => x.customerid == result.customerid);
            if (i > -1) this.customers.splice(i, 1);
            i = this.customersLoaded.findIndex(x => x == result.customerid);
            if (i > -1) this.customersLoaded.splice(i, 1);
          }
          let index = this.customers.findIndex(x => x.customerid == result.customerid);
          if (index === -1) this.customers.push(result);
          else if (!this.customers[index].isValidated) {
            this.customers[index] = result;
          }
          if (!this.customersLoaded.find(x => x == result.customerid)) this.customersLoaded.push(result.customerid);
        };
        break;
      case WistaAMSTypes.IssueState:
        url = "api/issue-status/" + res.identfier;
        break;
      case WistaAMSTypes.ContactPersonal:
        url = "api/contactpersonal/" + res.identfier;
        onLoaded = (result: ContactPersonal) => {
          let i = this.contactPersonalLoading.indexOf(res.identfier);
          if (i > -1) this.contactPersonalLoading.splice(i, 1);
          if (overwrite) {
            i = this.contactPersonal.findIndex(x => x.contactpersid == result.contactpersid);
            if (i > -1) this.contactPersonal.splice(i, 1);
            i = this.contactPersonalLoaded.findIndex(x => x == result.contactpersid);
            if (i > -1) this.contactPersonalLoaded.splice(i, 1);
          }
          if (result && !this.contactPersonal.find(x => x.contactpersid == result.contactpersid)) this.contactPersonal.push(result);
          if (result && !this.contactPersonalLoaded.find(x => x == result.contactpersid)) this.contactPersonalLoaded.push(result.contactpersid);
        }
        break;
      case WistaAMSTypes.IssueType:
        url = "api/issuetype/" + res.identfier;
        break;
      case WistaAMSTypes.Offer:
        url = "api/offer/" + res.identfier;
        onLoaded = (result: Offer) => {
          let i = this.offersLoading.indexOf(res.identfier);
          if (i > -1) this.offersLoading.splice(i, 1);
          if (overwrite) {
            i = this.offers.findIndex(x => x.offerid == result.offerid);
            if (i > -1) this.offers.splice(i, 1);
            i = this.offersLoaded.findIndex(x => x == result.offerid);
            if (i > -1) this.offersLoaded.splice(i, 1);
          }
          if (!this.offers.find(x => x.offerid == result.offerid)) this.offers.push(result);
          if (!this.offersLoaded.find(x => x == result.offerid)) this.offersLoaded.push(res.identfier);
        };
        break;
      case WistaAMSTypes.ProductPicture:
        url = "api/product/" + res.identfier + "/previewpicture";
        onLoaded = (result: ProductPicture) => {
          this.productPictureMap[result.productid] = result;
        }
        break;
      case WistaAMSTypes.ProductInGroup:
        url = "api/product/group/" + res.identfier;
        onLoaded = (result: Product[]) => {
          for (let product of result) {
            if (!this.products.find(x => x.productid == product.productid)) this.products.push(product);
          }
          this.productInGroupsLoaded.push(res.identfier);
        }
        break;
      case WistaAMSTypes.Product:
        url = "api/product/" + res.identfier;
        onLoaded = (result: Product) => {
          let i = this.products.findIndex(x => x.productid == res.identfier);
          if (i == -1) this.products.push(result);
        }
        break;
      case WistaAMSTypes.CustomerContracts:
        url = "api/customer/" + res.identfier + "/contracts";
        onLoaded = (result: Contract[]) => {
          for (let contract of result) {
            if (!this.contracts.find(x => x.contractid == contract.contractid)) this.contracts.push(contract);
          }
          this.customerContractsLoaded.push(res.identfier);
        }
        break;
      case WistaAMSTypes.CustomerOffers:
        url = "api/customer/" + res.identfier + "/offers";
        onLoaded = (result: Offer[]) => {
          for (let offer of result) {
            if (!this.offers.find(x => x.offerid == offer.offerid)) this.offers.push(offer);
          }
          this.customerOffersMap[res.identfier.toString()] = result;
        }
        break;
      case WistaAMSTypes.IssueOffers:
        url = "api/issue/" + res.identfier + "/offers";
        onLoaded = (result: Offer[]) => {
          for (let offer of result) {
            if (!this.offers.find(x => x.offerid == offer.offerid)) this.offers.push(offer);
            if (!this.offersLoaded.find(x => x == offer.offerid)) this.offersLoaded.push(offer.offerid);
          }
          this.issueOffersLoaded.push(res.identfier);
        }
        break;
      case WistaAMSTypes.IssueMails:
        url = "api/issue/" + res.identfier + "/emails";
        onLoaded = (result: IssueMail[]) => {
          for (let mail of result) {
            if (!this.issueMails.find(x => x.id == mail.id)) this.issueMails.push(mail);
            if (!this.issueMailsLoaded.find(x => x == mail.id)) this.issueMailsLoaded.push(mail.id);
          }
          this.issueMailsLoaded.push(res.identfier);
        }
        break;
      case WistaAMSTypes.Contract:
        url = "api/contract/" + res.identfier;
        onLoaded = (result: Contract) => {
          let i = this.contractsLoading.indexOf(res.identfier);
          if (i > -1) this.contractsLoading.splice(i, 1);
          if (overwrite) {
            i = this.contracts.findIndex(x => x.contractid == result.contractid);
            if (i > -1) this.contracts.splice(i, 1);
            i = this.contractsLoaded.findIndex(x => x == result.contractid);
            if (i > -1) this.contractsLoaded.splice(i, 1);
          }
          if (!this.contracts.find(x => x.contractid == result.contractid)) this.contracts.push(result);
          if (!this.contractsLoaded.find(x => x == result.contractid)) this.contractsLoaded.push(res.identfier);
        }
        break;
      case WistaAMSTypes.ContractState:
        url = "api/contract-status/" + res.identfier;
        onLoaded = (result: ContractState) => {
          if (!this.contractStatesLoaded.find(x => x == result.contractstateid)) {
            this.contractStatesLoaded.push(result.contractstateid);
            this.contractStates.push(result);
          }
        }
        break;
      case WistaAMSTypes.ContractType:
        url = "api/contracttype/" + res.identfier;
        onLoaded = (result: ContractType) => {
          if (!this.contractTypesLoaded.find(x => x == result.contracttypeid)) {
            this.contractTypesLoaded.push(result.contracttypeid);
            this.contractTypes.push(result);
          }
        }
        break;
      case WistaAMSTypes.Address:
        url = "api/address/" + res.identfier;
        break;
      case WistaAMSTypes.Location:
        url = "api/location/" + res.identfier;
        onLoaded = (result: Location) => {
          let i = this.locationsLoading.indexOf(res.identfier);
          if (i > -1) this.locationsLoading.splice(i, 1);
          if (overwrite) {
            i = this.locations.findIndex(x => x.locationid == result.locationid);
            if (i > -1) this.locations.splice(i, 1);
            i = this.locationsLoaded.findIndex(x => x == result.locationid);
            if (i > -1) this.locationsLoaded.splice(i, 1);
          }
          if (!this.locations.find(x => x.locationid == result.locationid)) this.locations.push(result);
          if (!this.locationsLoaded.find(x => x == result.locationid)) this.locationsLoaded.push(res.identfier);
        }
        break;
      case WistaAMSTypes.LocationAvailabilities:
        url = "api/location/" + res.identfier + "/availabilities";
        onLoaded = (result: Availability[]) => {
          this.locationAvailabilitiesLoaded.push(res.identfier);
          for (let availability of result) if (!this.availabilities.find(x => x.availabilityid == availability.availabilityid)) this.availabilities.push(availability);
        }
        break;
    }
    if (url) {
      this._backEndService.get(url).subscribe((object: any) => {
        onLoaded(object);
        res.handle.next(object);
      });
    } else throw ("error: cannot resolve type " + res.identfier);
  }

  static checkChange(change: ChangeModel<any>, result: ResponseWrapper<any>) {
    if (this.changeIsPersisted(change)) change.allChangesPersistedObservable.next(result);
    else change.changePersistedObservable.next(result);
  }

  static changeIsPersisted(change: ChangeModel<any>): boolean {
    if (change.newModelIsPersisted && (!Array.isArray(change.scheduleTasks) || change.scheduleTasks.length == 0) && (!Array.isArray(change.uploadTasks) || change.uploadTasks.length == 0) && (!Array.isArray(change.availabilityTasks) || change.availabilityTasks.length == 0)) return true;
    return false;
  }

  removeShoppingCart(cart: ShoppingCart) {
    let index = this.shoppingCarts.indexOf(cart);
    if (index > -1) this.shoppingCarts.splice(index, 1);
  }

  saveTasks(response: TaskResponse, tasks: Task[]) {
    const notificationTaskMap = [];
    var notificationTaskCallback = (task: Task, receiver: string, result: any) => {
      let entry = notificationTaskMap.find(x => x.task == task);
      if (!entry) {
        entry = { task: task, results: [] };
        notificationTaskMap.push(entry);
      }
      entry.results.push(result);
      response.onPartialTaskSaved.next({ "task": task, "result": result, "receiver": receiver });
      let index = (task as NotificationTask).receiver.indexOf(receiver);
      if (index > -1) {
        (task as NotificationTask).receiver.splice(index, 1);
        if ((task as NotificationTask).receiver.length == 0) callback(task, notificationTaskMap.find(x => x.task == task));
      }
    };
    var callback = (task: Task, result: any) => {
      response.onTaskSaved.next({ "task": task, "result": result });
      let i = tasks.indexOf(task);
      if (i > -1) {
        tasks.splice(i, 1);
        if (tasks.length == 0) response.onAllTasksExecuted.next();
      }
    };
    var errorCallback = (task: Task, result: any) => {
      response.errorCount++;
      response.onTaskSaved.error({ "task": task, "result": result });
      let i = tasks.indexOf(task);
      if (i > -1) {
        tasks.splice(i, 1);
        if (tasks.length == 0) response.onAllTasksExecuted.next();
      }
    };
    for (let task of tasks) {
      switch (task.taskType) {
        case TaskType.CreateEventTask:
          this._backEndService.post("api/nextcloud/calendar/event", {
            id: (task as CreateEventTask).event.id,
            title: (task as CreateEventTask).event.title,
            start: moment((task as CreateEventTask).event.start).format("YYYYMMDDTHHmmss"),
            end: moment((task as CreateEventTask).event.end).format("YYYYMMDDTHHmmss"),
            href: (task as CreateEventTask).event.href
          } as CalendarEntry).subscribe(
            (result) => {
              callback(task, result);
            },
            (result) => {
              errorCallback(task, result);
            }
          );
          break;
        case TaskType.CreateUserFilterTask:
          this._backEndService.post(
            "api/userfilter",
            (task as CreateUserFilterTask).filter
          ).subscribe(
            (result) => {
              callback(task, result);
            },
            (result) => {
              errorCallback(task, result);
            }
          );
          break;
        case TaskType.TransformIssueItemsTask:
          this._backEndService.post(
            "api/issueitem/transform-to-contract-items",
            {
              "map": (task as TransformIssueItemsTask).maps
            }
          ).subscribe(
            (result) => {
              callback(task, result);
            },
            (result) => {
              errorCallback(task, result);
            }
          );
          break;
        case TaskType.NotificationTask:
          switch ((task as NotificationTask).type) {
            case NotificationTaskType.Internal:
              for (let receiver of (task as NotificationTask).receiver) {
                this._backEndService.post("api/notification", {
                  notificationsubject: (task as NotificationTask).subject,
                  notificationtext: (task as NotificationTask).content,
                  notificationuser: receiver
                } as Notification).subscribe((notification: Notification) => notificationTaskCallback(task, receiver, notification));
              }
              break;
            case NotificationTaskType.EMail:
              /*
              for (let receiver of (task as NotificationTask).receiver) {
                if (!receiver) {
                  notificationTaskCallback(task, receiver, null);
                  continue;
                }
                let callback = (form: FormData) => {
                  this._backEndService.post("api/mail", form).subscribe((notification: Notification) => notificationTaskCallback(task, receiver, notification));
                };
                let extractedImages = this.extractImagesToBlobs((task as NotificationTask).content);
                let formData = extractedImages.formData;
                formData.append("mail", new Blob([JSON.stringify({
                  body: extractedImages.body,
                  subject: (task as NotificationTask).subject,
                  receiver: receiver
                } as Mail)], {
                  type: "application/json"
                }));
                if ((task as NotificationTask).attachements.length === 0) callback(formData);
                var resolved = 0;
                for (let attachement of (task as NotificationTask).attachements) {
                  if (attachement.isNextcloudFile) {
                    this._fileService.getFileByPath((attachement as NextcloudFile).href).subscribe((blob: Blob) => {
                      formData.append(this.getFileName(attachement as NextcloudFile), blob, this.getFileName(attachement as NextcloudFile));
                      resolved++;
                      if (resolved === (task as NotificationTask).attachements.length) callback(formData);
                    });
                  } else {
                    console.warn("don't know how to handle file, drop it ...", attachement);
                    resolved++;
                    if (resolved === (task as NotificationTask).attachements.length) callback(formData);
                  }
                }
              }
              */
              break;
          }
          break;
        case TaskType.ScheduleUserTask:
          if ((task as ScheduleUserTask).schedule) this._backEndService.assignUser((task as ScheduleUserTask).issue.issueid, (task as ScheduleUserTask).user.id).subscribe(
            (result) => {
              callback(task, result);
            },
            (result) => {
              errorCallback(task, result);
            }
          );
          else this._backEndService.get("api/issue/" + (task as ScheduleUserTask).issue.issueid + "/unassign/" + (task as ScheduleUserTask).user.id).subscribe(
            (result) => {
              callback(task, result);
            },
            (result) => {
              errorCallback(task, result);
            }
          );
          break;
        case TaskType.UploadTask:
          if ((task as UploadTask).upload) {
            let f = (((task as UploadTask).file) as LocalFile).blob;
            let data = new FormData();
            data.append(f.name, f, f.name);
            this._fileService.uploadFile((task as UploadTask).href, data).subscribe(
              (result) => {
                callback(task, result);
              }, (result) => {
                errorCallback(task, result);
              }
            );
          }
          break;
        case TaskType.MailUploadTask:
          /*
          if ((task as MailUploadTask).upload) {
            this._fileService.downloadMailAttachement((task as MailUploadTask).file).subscribe((blob: Blob) => {
              let data = new FormData();
              data.append((task as MailUploadTask).file.name, blob, (task as MailUploadTask).file.name);
              this._fileService.uploadFile((task as MailUploadTask).href, data).subscribe(
                (result) => {
                  callback(task, result);
                },
                (result) => {
                  errorCallback(task, result);
                }
              );
            });
          }
          */
          break;
        default:
          console.warn("unknwon task type", task);
          break;
      }
    }
  }

  searchCustomer(term: string, soft: boolean = false): Observable<Customer[]> {
    var key = '_';
    if (typeof (term) === 'string') {
      term = term.trim().toLocaleLowerCase();
      key = term;
    }
    if (soft && this.customerReplays[key]) return this.customerReplays[key];
    this.customerReplays[key] = (this._backEndService.post("api/customer/search", {
      searchString: term
    } as SearchObject) as Observable<Customer[]>).pipe(
      tap((result: Customer[]) => {
        for (let customer of result) {
          customer.isValidated = false;
          if (!this.customers.find(x => x.customerid == customer.customerid)) this.customers.push(customer);
        }
        this.customersSearched.push(term);
        this.customersSearchedAnchor.next();
      }),
      shareReplay(1)
    );
    return this.customerReplays[key];
  }

  searchContactperson(term: string): Observable<ContactPersonal[]> {
    if (this.contactpersonsSearched.includes(term)) {
      this.contactpersonsSearchedAnchor.next();
      return of(this.contactPersonal);
    } else {
      let callback = new Subject<ContactPersonal[]>();
      this._backEndService.post("api/contactpersonal/search", {
        searchString: term
      } as SearchObject).subscribe((result: ContactPersonal[]) => {
        for (let contactperson of result) {
          if (!this.contactPersonal.find(x => x.contactpersid == contactperson.contactpersid)) this.contactPersonal.push(contactperson);
        }
        this.contactpersonsSearched.push(term);
        this.contactpersonsSearchedAnchor.next();
        callback.next(result);
        callback.complete();
      });
      return callback.asObservable();
    }
  }

  searchContracts(term: string) {
    if (this.contractsSearched.includes(term)) {
      this.contractsSearchedAnchor.next();
    } else {
      this._backEndService.post("api/contract/search", {
        searchString: term
      } as SearchObject).subscribe((result: Contract[]) => {
        for (let contract of result) {
          if (!this.contracts.find(x => x.contractid == contract.contractid)) this.contracts.push(contract);
        }
        this.contractsSearched.push(term);
        this.contractsSearchedAnchor.next();
      });
    }
  }

  searchLocations(term: string) {
    if (this.locationsSearched.includes(term)) {
      this.locationsSearchedAnchor.next();
    } else {
      this._backEndService.post("api/location/search", {
        searchString: term
      } as SearchObject).subscribe((result: Location[]) => {
        for (let location of result) {
          if (!this.locations.find(x => x.locationid == location.locationid)) this.locations.push(location);
        }
        this.locationsSearched.push(term);
        this.locationsSearchedAnchor.next();
      });
    }
  }
  /**
   * the method searches for issues in accordance to the issue type
   * @param term 
   * @param type 
   */
  searchIssue(term: string, type: number) {
    let array;
    let url;
    switch (type) {
      case this.issueTypeId:
        array = this.issuesSearched;
        url = "issue";
        break;
      case this.changeTypeId:
        array = this.changesSearched;
        url = "change";
        break;
      case this.projectTypeId:
        array = this.projectsSearched;
        url = "project";
        break;
      case this.incidentTypeId:
        array = this.incidentsSearched;
        url = "incident";
        break;
    }
    if (!array || !url) throw ("error: cannot recognize type " + type);
    if (array.includes(term)) {
      this.issuesSearchedAnchor.next();
    } else {
      this._backEndService.post("api/" + url + "/search", {
        searchString: term
      } as SearchObject).subscribe((result: Issue[]) => {
        for (let issue of result) {
          if (!this.issues.find(x => x.issueid == issue.issueid)) this.issues.push(issue);
        }
        array.push(term);
        this.issuesSearchedAnchor.next();
      });
    }
  }

  searchOffers(term: string) {
    if (this.offersSearched.includes(term)) {
      this.offersSearchedAnchor.next();
    } else {
      this._backEndService.post("api/offer/search", {
        searchString: term
      } as SearchObject).subscribe((result: Offer[]) => {
        for (let offer of result) {
          if (!this.offers.find(x => x.offerid == offer.offerid)) this.offers.push(offer);
        }
        this.offersSearchedAnchor.next();
      });
    }
  }

  searchAddresses(term: string) {
    if (this.addressesSearched.includes(term)) {
      this.addressesSearchedAnchor.next();
    } else {
      this._backEndService.post("api/address/search", {
        searchString: term
      } as SearchObject).subscribe((result: Address[]) => {
        for (let address of result) {
          if (!this.addresses.find(x => x.addressid == address.addressid)) this.addresses.push(address);
        }
        this.addressesSearchedAnchor.next();
      });
    }
  }

  searchProduct(term: string) {
    if (this.productsSearched.includes(term)) {
      this.productsSearchedAnchor.next();
    } else {
      this._backEndService.post("api/product/search", {
        searchString: term
      } as SearchObject).subscribe((result: Product[]) => {
        for (let product of result) {
          if (!this.products.find(x => x.productid == product.productid)) this.products.push(product);
        }
        this.productsSearched.push(term);
        this.productsSearchedAnchor.next();
      });
    }
  }

  setIssueFilesExportedFlag(issueId: number, value: boolean): Observable<Object> {
    return this._backEndService.get(`api/issue/${issueId}/files-archived/${value}`);
  }

  createNewWidget(widget: Widget) {
    return this._backEndService.post("api/widget", {
      content: {
        widgetid: widget.widgetid,
        widgetuser: widget.widgetuser,
        widgetx: widget.widgetx,
        widgety: widget.widgety,
        widgeth: widget.widgeth,
        widgetw: widget.widgetw,
        widgettype: widget.widgettype
      }
    } as GenericPostRequest<Widget>);
  }
  /**
   * the method loads the user startpage's widgets
   */
  loadStartpage() {
    this.startPageLoading = true;
    this._httpClient.get(`${serverLocation}/api/widget/current`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }).subscribe((widgets: Widget[]) => {
      this.startPage = widgets;
      this.startPageLoaded = true;
      this.startPageLoading = false;
      this.startPageLoadedAnchor.next();
    });
  }
  /**
   * the method loads all newsfeed observables
   */
  loadNewsfeedObservables() {
    this.newsfeedObservablesLoading = true;
    this._backEndService.get("api/newsfeed/observable").subscribe((observable: any) => {
      this.newsfeedObservables = observable;
      this.newsfeedObservablesLoaded = true;
      this.newsfeedObservablesLoading = false;
      this.newsfeedObservablesLoadedAnchor.next();
    });
  }
  /**
   * the method extracts the embedded base64 images and returns a cleared body representation and the extracted images
   */
  extractImagesToBlobs(body: string): EMailImagesToBlobModel {
    let formData: FormData = new FormData();
    var guid;
    let regExp = /\<img *src=\"(.*?)\">/g;
    var match;
    var replaceIntervals = [];
    while ((match = regExp.exec(body)) != null) {
      guid = Guid.newGuid();
      let srcInner = /data:(.*?);/.exec(match[0]);
      let mediaType = srcInner[1];
      let subMediaType = mediaType.split("/")[1];
      let fullName = guid + "." + subMediaType;
      let dataArray = (match[1] as string).split(",");
      let base64 = dataArray[1];
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mediaType });
      formData.append(fullName, blob, fullName);
      replaceIntervals.push({ from: (match.index + srcInner.index), length: match[1].length, cid: fullName });
    }
    var cleared: string = "";
    var last = 0;
    for (let interval of replaceIntervals) {
      cleared += body.substr(last, (interval.from - last)) + "cid:" + interval.cid;
      last = interval.from + interval.length;
    }
    cleared += body.substr(last, (body.length - 1));
    return {
      body: cleared,
      formData: formData
    } as EMailImagesToBlobModel;
  }
  /**
   * the method returns a nextcloud file's name from the href
   * @param nextcloud file
   * @returns filename
   */
  getFileName(file: NextcloudFile): string {
    if (file.type == "folder") {
      let array = file.href.split("/");
      if (array.length > 1) {
        return array[array.length - 2];
      }
    } else {
      let array = file.href.split("/");
      if (array.length > 0) {
        return array[array.length - 1];
      }
    }

    return "unknown";
  }
}

export class ReplaceNotificationDataWrapper {
  issue?: Issue;
  issueCreator?: User;
  issueState?: IssueState;
  issueType?: IssueType;
  issueCustomer?: Customer;
  transaction?: any;
  transactionResultState?: IssueState;
}

export class NewsfeedObservableEntry {
  create: string;
  delete: string;
  edit: string;
  identifier: string;
}

export class ObservableResolver {
  public identfier: number;
  public handle: Subject<any> = new Subject();
  public type: number;
}

export class TaskResponse {
  errorCount: number = 0;
  onMainObjectSavingStarted: Subject<any> = new Subject();
  onMainObjectSaved: Subject<any> = new Subject();
  onPartialTaskSaved: Subject<any> = new Subject();
  onTaskSavingStarted: Subject<any> = new Subject();
  onTaskSaved: Subject<any> = new Subject();
  onAllTasksExecuted: Subject<void> = new Subject();
}

export class ResolveObject {
  type: number;
  identifier;
  callback;
  overwrite: boolean = false;
  constructor(type: number, identfier, callback?, overwrite?: boolean) {
    this.type = type;
    this.identifier = identfier;
    this.callback = callback;
    if (typeof callback === 'function') this.callback = callback;
    if (typeof overwrite === 'boolean') this.overwrite = overwrite;
  }
}

export class ResolveResponse {
  arg: ResolveObject;
  result;
}

export class ResolveResponseWrapper {
  onResolved: Subject<ResolveResponse> = new Subject();
  onAllResolved: Subject<ResolveResponse[]> = new Subject();

  dispose() {
    this.onAllResolved.complete();
    this.onResolved.complete();
  }
}

export class EMailImagesToBlobModel {
  body: string;
  formData: FormData;
}